import styled from 'styled-components';
import { tablet768 } from '@nubank/nuds-web/styles/breakpoints';

import Section from 'components/structure/Section';
import { paddingBuilder } from 'styles/themeUtils';

const SectionRoot = styled(Section)`
  ${tablet768`
    ${paddingBuilder.all(0, 3.5)}
  `}
`;

SectionRoot.defaultProps = {
  minHeight: '0px',
};

SectionRoot.displayName = 'SectionRoot';

export default SectionRoot;
